var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analytics-text-filter"},[(!_vm.hideInput)?_c('ds-input-field',{model:{value:(_vm.filter.value),callback:function ($$v) {_vm.$set(_vm.filter, "value", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"filter.value"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }